module.exports = __webpack_public_path__ + "static/media/colorado.7bc0133f.svg";